const LightTheme={
    pageBackground:"rgb(244,246,246)",
    titleColor: "#000000",
    cardColor:"#f9f9f9",
    cardShadow:"-9.1159px -18.2318px 24.3091px #fff, 9.1159px 18.2318px 24.3091px #eceef1;",
    inputColor: "#000000"
}

const DarkTheme= {
    pageBackground: "#000000",
    titleColor: "#ffffff",
    cardColor: "rgb(9, 9, 10)",
    cardShadow:"-9.1159px -18.2318px 24.3091px #000, 9.1159px 18.2318px 24.3091px #252526;",
    inputColor: "#ffffff"
}
export const themes={
    light: LightTheme,
    dark: DarkTheme
}